import { isLebtServiceFeesEnabled } from 'businessTraveller/selectors/businessTravellerServiceFeesSelectors'
import { createSelector } from 'reselect'

export const getBusinessTravellerCreditTotals = createSelector(
  (state: App.State) => state.businessTraveller.cartEvaluation,
  (
    cartEvaluation,
  ): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const total = cartEvaluation.result?.businessCreditItem?.total ?? 0
    return {
      hasRequiredData: true,
      data: {
        price: total,
        businessTravellerCredits: total,
        memberPrice: 0,
        taxesAndFees: 0,
        value: 0,
        memberValue: 0,
        surcharge: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)

export const getBusinessTravellerCheckoutServiceFeeTotal = createSelector(
  (state: App.State) => state.checkout.cart.cartId,
  (state: App.State) => state.checkout.cart.mode,
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.businessTraveller.serviceFees,
  (state: App.State) => isLebtServiceFeesEnabled(state),
  (
    cartId,
    cartMode,
    existingOrder,
    serviceFees,
    lebtServiceFeesEnabled,
  ): number => {
    if (!lebtServiceFeesEnabled) {
      return 0
    }

    if (cartMode === 'custom-offer') {
      return existingOrder?.serviceFee?.total ?? 0
    }

    return serviceFees[cartId]?.amount ?? 0
  },
)

export const getBusinessTravellerCheckoutServiceFeeTotals = createSelector(
  (state: App.State) => state.checkout.cart.cartId,
  (state: App.State) => state.checkout.cart.mode,
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.businessTraveller.serviceFees,
  (state: App.State) => isLebtServiceFeesEnabled(state),
  (
    cartId,
    cartMode,
    existingOrder,
    serviceFees,
    lebtServiceFeesEnabled,
  ): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    let price: number = 0

    if (lebtServiceFeesEnabled) {
      if (cartMode === 'custom-offer') {
        price += existingOrder?.serviceFee?.total ?? 0
      } else {
        price += serviceFees[cartId]?.amount ?? 0
      }
    }

    return {
      hasRequiredData: true,
      data: {
        price,
        memberPrice: 0,
        taxesAndFees: 0,
        value: 0,
        memberValue: 0,
        surcharge: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)

// Transforms businessBookingDetails into checkout fields: [{ fieldId: <UUID>, value: <string> }]
export const getBusinessBookingCheckoutFields = createSelector(
  (state: App.State) => state.checkout.cart.businessBookingDetails,
  (businessBookingDetails): Array<App.CheckoutFieldPayload> | undefined => {
    if (!businessBookingDetails || Object.keys(businessBookingDetails).length === 0) {
      return undefined
    }
    return Object.entries(businessBookingDetails)
      .map(([fieldId, value]) => ({ fieldId, value: String(value).trim() }))
      .filter((field) => field.value !== '')
  },
)
